<template>
  <div>
    <v-toolbar
      class="action-icons-bar"
      height="67px"
      card
      :style="{'background-color': this.$store.state.campaign.color }"
    >
      <v-toolbar-title>
        <v-btn
          icon
          v-if="this.$store.state.isLowRes"
          @click.native="minimizeWindow"
          class="left-arrow-back"
        >
          <v-icon
            :style="{'color': invertColor(this.$store.state.campaign.color)}"
            style="font-size: 28px !important;"
          >keyboard_arrow_left</v-icon>
        </v-btn>
        <div
          class="avatar-agent-pic"
          :class="{ 'isLowRes' : this.$store.state.isLowRes }"
          v-if="$store.state.campaign.show_agent && !$store.state.interaction.transfering"
          :style="{'background-image' : 'url(' + $store.state.menu.menu_img + ')'}"
        ></div>
        <div
          class="avatar-agent-pic"
          :class="{ 'isLowRes' : this.$store.state.isLowRes }"
          v-else-if="!$store.state.campaign.show_agent && !$store.state.interaction.transfering && $store.state.campaign.logo"
          :style="{'background-image' : 'url('+ $store.state.campaign.logoName+')'}"
        ></div>
        <div
          class="avatar-agent-pic"
          :class="{ 'isLowRes' : this.$store.state.isLowRes }"
          v-else-if="!$store.state.interaction.transfering"
          :style="{'background-image' : 'url(' + avatar + ')'}"
        ></div>

        <div
          class="avatar-agent-pic"
          :class="{ 'isLowRes' : this.$store.state.isLowRes }"
          v-else-if="$store.state.interaction.transfering"
        >
          <v-icon
            :style="{'color': invertColor(this.$store.state.campaign.color)}"
            style="font-size: 50px !important;"
            class="spinIcon">
            sync
          </v-icon>
        </div>

        <span
          class="agent-name"
          :class="{ 'isLowRes' : this.$store.state.isLowRes }"
          v-if="$store.state.campaign.show_agent && !$store.state.interaction.transfering"
          :style="{'color':invertColor($store.state.campaign.color)}"
        >{{$store.state.interaction.agent}}</span>
        <span
          class="agent-name"
          :class="{ 'isLowRes' : this.$store.state.isLowRes }"
          v-else-if="!$store.state.campaign.show_agent && !$store.state.interaction.transfering"
          :style="{'color':invertColor($store.state.campaign.color)}"
        >CHAT</span>

        <span
          class="agent-name"
          :class="{ 'isLowRes' : this.$store.state.isLowRes }"
          v-else-if="$store.state.interaction.transfering"
          :style="{'color':invertColor($store.state.campaign.color)}"
        >{{$t('transfering')}}</span>
        <p
          v-if="!$store.state.interaction.transfering"
          class="response-time"
          :class="{ 'isLowRes' : this.$store.state.isLowRes }"
          :style="{'color':invertColor($store.state.campaign.color)}"
        >{{$t('available')}}</p>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-tooltip v-if="allowedCalls && hasWebRTC && !hideButtons && !$store.state.interaction.transfering" bottom>
          <v-btn slot="activator" class="chatbar-button" icon @click.stop.prevent="videoCall">
            <v-icon :style="{'color': invertColor(this.$store.state.campaign.color)}">videocam</v-icon>
          </v-btn>
          <span>{{$t('videocall')}}</span>
        </v-tooltip>
        <v-tooltip v-if="allowedCalls && hasWebRTC && !hideButtons && !$store.state.interaction.transfering" bottom>
          <v-btn slot="activator" class="chatbar-button" icon @click.stop.prevent="makeCall">
            <v-icon :style="{'color': invertColor(this.$store.state.campaign.color)}">phone</v-icon>
          </v-btn>
          <span>{{$t('call')}}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <v-btn slot="activator" class="chatbar-button" icon @click.native="openCloseModal">
            <v-icon :style="{'color': invertColor(this.$store.state.campaign.color)}">close</v-icon>
          </v-btn>
          <span>{{$t('endchat')}}</span>
        </v-tooltip>
      </v-toolbar-items>
    </v-toolbar>
  </div>
</template>

<script>
import DetectRTC from "detectrtc";
import Avatar from "../assets/avatar.png";
import { invertColor } from "@/assets/utils";


export default {
  name: "chat-toolbar",
  props: {hideEndConv: Boolean, isBot: Boolean},
  data() {
    return {
      avatar: Avatar,
      hasWebRTC: false
    };
  },

  computed: {
    getVisiblePhoneIcons() {
      return this.hasWebRTC;
    },
    isIOS() {
      return this.$store.state.isIOS;
    },

    isMobile() {
      return this.$store.state.isMobile;
    },

    allowedCalls() {
      return this.$store.state.campaign.allow_call;
    },
    
    hideButtons(){
      return this.hideEndConv || this.isBot;
    }

  },

  created() {
    DetectRTC.load(() => {
      this.hasWebRTC = DetectRTC.isWebRTCSupported;
    });
  },

  methods: {
    isChrome(){
      return navigator.userAgent.indexOf("CriOS") > -1;
    },
    makeCall() {
      this.$emit("clickCallEv");
    },

    videoCall() {
      this.$emit("clickVideoCallEv");
    },

    openCloseModal() {
      this.$emit("openConfirmationModal");
    },

    /**
     * @name MINIMIZE_WINDOW
     * @desc Broadcast event to entrypoint to minimize the chat
     */
    minimizeWindow() {
      window.parent.postMessage({ action: "MINIMIZE" }, "*");
    },

    invertColor
  }
};
</script>

<style>
.action-icons-bar > .v-toolbar__content > .v-toolbar__title {
  width: 212px;
}
</style>

<style scoped>
.rounded-borders {
  border-radius: 6px 6px 0 0 !important;
}

.response-time {
  width: 142px;
  font-size: 11px;
  position: relative;
  color: #ffffffb5;
  left: 60px;
  opacity: 0.7;
  top: 17px;
  letter-spacing: -0.3px;
  white-space: pre-wrap;
  overflow: initial;
  text-overflow: ellipsis;
}

.response-time.isLowRes {
  left: 85px;
}

.action-icons-bar {
  z-index: 5;
  height: 75px;
  margin-top: 1em;
  position: absolute top;
  background-size: 100%;
  cursor: pointer;
  letter-spacing: -0.2px;
  padding-top: 8px;
  font-family: "Montserrat", sans-serif;
}

.action-icons-bar::after {
  content: "";
  background: linear-gradient(
    135deg,
    rgba(35, 146, 236, 0),
    rgba(0, 0, 0, 0.29)
  );
  background-blend-mode: overlay;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  z-index: -1;
}

.chatbar-button {
  width: 36px !important;
  height: 36px !important;
  margin-top: 12px !important;
  margin-right: 8px !important;
}

.action-icons-bar .v-toolbar__content .v-toolbar__items {
  position: relative;
  right: -10px;
}

.avatar-agent-pic {
  width: 47px;
  height: 47px;
  background-size: 106% 106%;
  border-radius: 50%;
  background-position: -1px 0px;
  position: absolute;
  left: 14px;
  top: 14px;
}

.avatar-agent-pic.isLowRes {
  position: absolute !important;
  left: 42px;
}

.agent-name {
  position: absolute;
  left: 77px;
  top: 10px;
  letter-spacing: -0.2px;
  width: 191px;
  font-size: 18px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.agent-name.isLowRes {
  position: absolute !important;
  left: 100px;
}

.left-arrow-back {
  position: absolute !important;
  left: -2px;
  bottom: 14px;
}

.spinIcon{
  animation-name: spin;
  animation-duration: 3000ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}
@keyframes spin {
    from {
        transform:rotate(0deg);
    }
    to {
        transform:rotate(360deg);
    }
}
</style>



// WEBPACK FOOTER //
// chat-toolbar.vue?4d51f777